// Chakra imports
import {
  Box,
  Button,
  Flex,
  IconButton,
  Image,
  Spinner,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
// Custom components
import Card from "components/card/Card";
import { useEffect, useState } from "react";
// Assets
import { MdClose, MdVerified } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setFormationId } from "redux/slices/certificateSlice";
import { selectPassTest, setCurrent } from "redux/slices/passTestSlice";
import { getProfileData } from "redux/slices/userSlice";

export default function Project(props: {
  id: number;
  title: string;
  testPassed: boolean;
  image: string;
  certificateLink: string;
  [x: string]: any;
}) {
  const { id, title, testPassed, image, certificateLink, ...rest } = props;
  // Chakra Color Mode
  const user = useAppSelector(getProfileData);
  const { current } = useAppSelector(selectPassTest);
  const [loading, setLoading] = useState<boolean>(false);

  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const brandColor = useColorModeValue("brand.500", "white");
  const history = useHistory();
  const [score, setScore] = useState(0);
  const dispatch = useAppDispatch();
  const bg = useColorModeValue("white", "navy.700");
  const navigateToCertificate = () => {
    dispatch(setFormationId(id));
    history.push("/user/profile/certificate");
  };
  useEffect(() => {
    const getPassedTest = async (id: number) => {
      try {
        setLoading(true);
        const res = await axios.get(
          `${apiurl}/pass-test/passedTest?userId=${user.userId}&testId=${id}`
        );
        setScore(res.data.score);
        dispatch(setCurrent(res.data));
        setLoading(false);
      } catch (error) {}
    };
    testPassed && getPassedTest(id);
  }, [id]);
  return (
    <Card bg={bg} {...rest} p="14px">
      <Flex align="center" direction={{ base: "column", md: "row" }}>
        <Image h="80px" w="80px" src={image} borderRadius="8px" me="20px" />
        <Box mt={{ base: "10px", md: "0" }}>
          <Text
            color={textColorPrimary}
            fontWeight="500"
            fontSize="md"
            mb="4px"
          >
            {title}
          </Text>
          <Text
            fontWeight="500"
            color={textColorSecondary}
            fontSize="sm"
            me="4px"
          >
            Test passé :{" "}
            <IconButton
              aria-label=""
              icon={testPassed ? <MdVerified /> : <MdClose />}
              color={testPassed ? "green.400" : "red.4000"}
            />
          </Text>
        </Box>
        {loading === true ? (
          <Spinner />
        ) : (
          testPassed &&
          score >= 90 && (
            <Button
              fontWeight="500"
              color={brandColor}
              onClick={navigateToCertificate}
              fontSize="sm"
            >
              Voir le certificat obtenu
            </Button>
          )
        )}
      </Flex>
    </Card>
  );
}
